import React from 'react';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import axios from 'axios';
import XLSX from 'xlsx';
import { isEmpty, isFunction } from 'lodash';
import { Label } from '../../../components';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import { formatDate, parseDate } from 'react-day-picker/moment';
import { SET_MESSAGE } from '../../../actions/utils';

export const Report = ({
  title,
  name,
  filter = false,
  formatter = [],
  dataSourceUrl = '/api/report?bankstaff',
  initialValues = {
    from: moment().subtract(1, 'months').toDate(),
    to: null,
  },
}) => {
  const [from, setFrom] = React.useState(initialValues?.from || null);
  const [to, setTo] = React.useState(initialValues?.to || null);
  const [loading, setLoading] = React.useState(false);
  const dispatch = useDispatch();

  const handleClick = async () => {
    const fromDate = filter ? moment(from).format('DD/MM/YYYY') : null;
    try {
      setLoading(true);
      let data = { name };
      if (from != null)
        data = {
          ...data,
          from: fromDate,
        };
      if (to != null) data = { ...data, to: moment(to).format('DD/MM/YYYY') };

      let res = await axios.post(dataSourceUrl, data);
      let { content, header, title, size } = res.data || {};
      console.log('content', content);

      let wb = XLSX.utils.book_new();
      wb.Props = {
        Title: 'Báo cáo',
        Subject: 'Báo cáo',
        Author: 'FWD',
        CreatedDate: new Date(),
      };

      let opts = isEmpty(header) ? {} : { header };
      let ws = XLSX.utils.json_to_sheet(content, opts);
      let i = 'A'.charCodeAt(0);
      let prefix = '';
      (title || []).map((t) => {
        let col = prefix + String.fromCharCode(i);
        let cell = col + '1';
        ws[cell].v = t;
        i = i + 1;
        if (i > 'Z'.charCodeAt(0)) {
          i = 'A'.charCodeAt(0);
          prefix = prefix ? String.fromCharCode(prefix.charCodeAt(0) + 1) : 'A';
        }
      });

      if (size?.length > 0) ws['!cols'] = (size || []).map((e) => ({ wch: e }));
      console.log('content', content);
      formatter.forEach((f) => (isFunction(f) ? f(ws, content) : null));

      wb.SheetNames.push('Data');
      wb.Sheets['Data'] = ws;
      let fileName = 'Report_' + moment().format('YYYYMMDD_hhmmss') + '.xlsx';
      XLSX.writeFile(wb, fileName);
      setLoading(false);
    } catch (error) {
      console.log(error);
      dispatch({ type: SET_MESSAGE, payload: ' ' });
      setLoading(false);
    }
  };

  return (
    <div className='report mt-4'>
      {title ? <div className='h4 text-primary'>{title}</div> : null}
      <div className='row col'>
        {filter ? (
          <>
            <div className='form-group mr-3'>
              <Label>Từ ngày</Label>
              <div>
                <DayPickerInput
                  format='DD/MM/YYYY'
                  formatDate={formatDate}
                  parseDate={parseDate}
                  placeholder='DD/MM/YYYY'
                  onDayChange={(date) => setFrom(date)}
                  value={from}
                  inputProps={{ className: 'form-control' }}
                />
              </div>
            </div>

            <div className='form-group mr-3'>
              <Label>Đến ngày</Label>
              <div>
                <DayPickerInput
                  format='DD/MM/YYYY'
                  formatDate={formatDate}
                  parseDate={parseDate}
                  placeholder='DD/MM/YYYY'
                  onDayChange={(date) => setTo(date)}
                  value={to}
                  inputProps={{ className: 'form-control' }}
                />
              </div>
            </div>
          </>
        ) : null}
      </div>
      <button type='button' className='btn btn-secondary text-uppercase' disabled={loading} onClick={handleClick}>
        Tải báo cáo
      </button>
      <hr />
    </div>
  );
};

export default Report;
